import { IReportsContext, IReportsState } from "./ReportsProviderTypes"

export const REPORTS_INITIAL_CONTEXT: IReportsContext = {
  reportDates: [],
  reportName: "",
  handleDateChange: () => {},
  generateReport: () => {},
  clearReport: () => {},
  handleDownloadReport: () => {},
  updateSelectedBranchesForReports: () => {},
  handleStatusCheckboxClick: () => {},
  handleWasherCheckboxClick: () => {},
  handleSourcesCheckboxClick: () => {},
  handleBoxCountCheckbox: () => {},
  selectedBranchesForReports: [],
  selectedStatusesForReports: [],
  selectedWashersForReports: [],
  selectedBoxes: [],
  selectedSourcesForReports: [],
  reportStatuses: [],
  reportSources: [],
  reportBoxes: 0,
  reportWashers: [],
  reportPreview: [],
}

export const REPORTS_INITIAL_STATE: IReportsState = {
  reportDates: [],
  reportName: "",
  selectedBranchesForReports: [],
  selectedStatusesForReports: [],
  selectedWashersForReports: [],
  selectedBoxes: [],
  selectedSourcesForReports: [],
  reportPreview: [],
}
